<template>
  <svg :aria-label="ariaLabel" :class="iconSizeClass" :data-qa="dataQA" :aria-hidden="ariaHidden" role="img" data-name="File Audio" class="d-icon d-icon--file-audio" viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M4.94 8.44a1.5 1.5 0 0 1 1.56-.354V8a2.5 2.5 0 1 0-5 0v.086a1.5 1.5 0 0 1 2 1.414v.5a1.5 1.5 0 0 1-3 0V8a3.5 3.5 0 1 1 7 0v2a1.5 1.5 0 0 1-3 0v-.5c0-.398.158-.78.44-1.06Zm.706.706A.5.5 0 0 1 6.5 9.5v.5a.5.5 0 0 1-1 0v-.5a.5.5 0 0 1 .146-.354Zm-4 0A.5.5 0 0 1 2.5 9.5v.5a.5.5 0 0 1-1 0v-.5a.5.5 0 0 1 .146-.354Z" fill="currentColor"/><path fill-rule="evenodd" clip-rule="evenodd" d="M1.946.946A1.49 1.49 0 0 1 3 .5h4.25a.5.5 0 0 1 .354.146l2.75 2.75a.5.5 0 0 1 .146.354V10c0 .387-.156.763-.446 1.054A1.49 1.49 0 0 1 9 11.5h-.25a.5.5 0 0 1 0-1H9a.488.488 0 0 0 .346-.154A.488.488 0 0 0 9.5 10V4.5H7a.5.5 0 0 1-.5-.5V1.5H3a.488.488 0 0 0-.346.154A.488.488 0 0 0 2.5 2v1.5a.5.5 0 0 1-1 0V2c0-.387.156-.763.446-1.054ZM9.043 3.5H7.5V1.957L9.043 3.5Z" fill="currentColor"/></svg>
</template>

<script>
import { ICON_SIZE_MODIFIERS } from '@/src/constants';

export default {
  name: 'DtIconFileAudio',

  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: [String, Number],
      default: 500,
      validator: (s) => Object.keys(ICON_SIZE_MODIFIERS).includes(String(s)),
    },

    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: undefined,
    },
  },

  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ['loaded'],

  computed: {
    iconSizeClass () {
      return ICON_SIZE_MODIFIERS[this.size];
    },

    ariaHidden () {
      return !this.ariaLabel ? 'true' : 'false';
    },

    dataQA () {
      return this.$attrs['data-qa'] ?? 'dt-icon';
    },
  },

  created () {
    this.$emit('loaded');
  },
};
</script>
